import React, { useEffect, useState } from "react";
import api from "../../utils/api/axiosInstance";
import styles from "../../styles/components/wizard/IdentityStickyPrompt.module.css";

/**
 * One-tap save of chat-extracted context into shopping identity.
 */
const IdentityStickyPrompt = ({
  proposal,
  onAccepted,
  onDismiss,
  acceptLabel = "Remember this",
  variant = "default",
}) => {
  const isGlass = variant === "glass";
  const [saving, setSaving] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    setDismissed(false);
    setSaving(false);
    setErrorMessage("");
  }, [proposal?.id]);

  if (!proposal?.fields || dismissed) return null;

  const handleAccept = async () => {
    try {
      setSaving(true);
      setErrorMessage("");
      const res = await api.post("/users/me/shopping-identity/accept-proposal", {
        fields: proposal.fields,
      });
      onAccepted?.(res.data);
      setDismissed(true);
    } catch {
      setSaving(false);
      setErrorMessage("Could not save right now. Please try again.");
    }
  };

  const handleDismiss = () => {
    setDismissed(true);
    onDismiss?.();
  };

  return (
    <div
      className={`${styles.prompt} ${isGlass ? styles.promptGlass : ""}`}
      role="region"
      aria-label="Remember for matching"
    >
      <p className={`${styles.message} ${isGlass ? styles.messageGlass : ""}`}>
        {proposal.message}
      </p>
      {Array.isArray(proposal.evidence) && proposal.evidence.length > 0 ? (
        <ul className={`${styles.evidence} ${isGlass ? styles.evidenceGlass : ""}`}>
          {proposal.evidence.map((line, index) => (
            <li key={`${index}-${line}`}>{line}</li>
          ))}
        </ul>
      ) : null}
      {errorMessage ? (
        <p className={`${styles.message} ${isGlass ? styles.messageGlass : ""}`} role="status" aria-live="polite">
          {errorMessage}
        </p>
      ) : null}
      <div className={styles.actions}>
        <button
          type="button"
          className={styles.acceptBtn}
          onClick={handleAccept}
          disabled={saving}
        >
          {saving ? "Saving…" : acceptLabel}
        </button>
        <button
          type="button"
          className={`${styles.dismissBtn} ${isGlass ? styles.dismissBtnGlass : ""}`}
          onClick={handleDismiss}
          disabled={saving}
        >
          Not now
        </button>
      </div>
    </div>
  );
};

export default IdentityStickyPrompt;
